<template>
  <main class="">
    <editEvent/>
  </main>
</template>

<script>
  import editEvent from '../../components/Pages/Journal/editEvent'
  export default {
    name: 'JournalCreatePage',
    components: { editEvent }
  }
</script>

<style lang="scss" scoped>
</style>

